import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

let configCache = null;

export function usePayPalConfig() {
  const [config, setConfig] = useState(configCache);
  useEffect(() => {
    if (configCache) {
      setConfig(configCache);
      return;
    }
    api
      .get("/payments/config")
      .then((res) => {
        configCache = res.data;
        setConfig(res.data);
      })
      .catch(() => setConfig({ configured: false }));
  }, []);
  return config;
}

export default function PayPalCheckout({ description, amount, testid = "paypal-pay-link" }) {
  const config = usePayPalConfig();

  if (config === null) {
    return (
      <div className="flex justify-center py-3">
        <Loader2 className="h-4 w-4 animate-spin text-blue-400" />
      </div>
    );
  }

  if (!config.configured) {
    return (
      <p className="rounded-lg border border-dashed border-white/10 px-4 py-3 text-center text-xs text-slate-500" data-testid="paypal-not-configured">
        Pagamento online em configuração — você também pode pagar no dia da aula
      </p>
    );
  }

  const params = new URLSearchParams({
    cmd: "_xclick",
    business: config.businessEmail,
    item_name: description,
    amount: String(amount),
    currency_code: config.currency,
    no_shipping: "1",
  });
  const href = `https://www.paypal.com/cgi-bin/webscr?${params.toString()}`;

  return (
    <div>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        className="flex w-full items-center justify-center gap-2 rounded-full bg-[#0070E0] py-3.5 font-mono text-xs font-medium uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:bg-[#0059B3]"
      >
        Pagar com PayPal
      </a>
      <p className="mt-3 text-center text-[11px] leading-relaxed text-slate-600">
        Você será redirecionado ao PayPal para pagar com segurança. O recibo chega por e-mail.
      </p>
    </div>
  );
}
